import React, { useEffect, useState } from "react";
import Slides from "./Slides";
import Pricing from "./Pricing";
import Brands from "./Brands";
import Work from "./Work";
import "./Homepage.css";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Scrollbar from "smooth-scrollbar";
import sal from "sal.js";
import "../../../node_modules/sal.js/dist/sal.css";

const Hompage = () => {

  useEffect(() => {
    sal();
    var options = {
      damping: 0.1,
    };
    Scrollbar.init(document.querySelector("#my-scrollbar"), options);
  });

  return (
    <div id="my-scrollbar">
      <Navbar />
      <Slides />
      <div className="what-we-do">
        <Work />
      </div>
      <Pricing />
      <Brands />
      <Footer />
    </div>
  );
};
export default Hompage;
